import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { useFormik } from "formik";
import { useCookies } from "react-cookie";
import CryptoJS from "crypto-js";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as yup from "yup";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import LoadingButton from "@mui/lab/LoadingButton";
import { actionTypes, useStateValue } from "../../store";
import {
  login,
  loginVerifyOtp,
  customerSignup,
  customerOTPVerify,
  googleCaptchaAPIKey,
} from "../../networkCalls";
import { useCallback } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const titleprofile = [
  {
    value: "Mr",
    label: "Mr.",
  },
  {
    value: "Mrs",
    label: "Mrs.",
  },
  {
    value: "Miss",
    label: "Miss.",
  },
  {
    value: "Ms",
    label: "Ms.",
  },
];

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    // .email('Enter a valid email')
    .required("Enter your email or mobile phone number"),
  // password: yup
  //     .string('Enter your password')
  //     .min(8, 'Password should be of minimum 8 characters length')
  //     .required('Password is required'),
});
const validationSchemaOTP = yup.object({
  otp: yup
    .string("Enter your OTP")
    .min(6, "Min 6 Digit")
    .max(6, "Max 6 Digit")
    .matches(/^[0-9]+$/, "Must be only digits")
    .required("You must specify a 6 Digit OTP"),
});
// 8595412681
const validationSchemaRegisOTP = yup.object({
  otp: yup
    .string("Enter your OTP")
    .min(6, "Min 6 Digit")
    .max(6, "Max 6 Digit")
    .matches(/^[0-9]+$/, "Must be only digits"),
  // otpemail: yup
  //     .string('Enter your OTP')
  //     .min(4, 'Min 4 Digit')
  //     .max(4, 'Max 4 Digit')
  //     .matches(/^[0-9]+$/, "Must be only digits")
});

const phoneRegExp = "(0|91)?[6-9][0-9]{9}";
const validationSchemaRegis = yup.object({
  email: yup
    .string("Enter your email")
    //.required()
    .notRequired()
    .email("Enter a valid email id"),
  cname: yup.string("Enter your first name").required("First name is required"),
  lname: yup.string("Enter your last name").required("Last name is required"),
  mobile: yup
    .string("")
    //.notRequired()
    .required("Mobile number is required")
    .matches(phoneRegExp, "Mobile number is not valid")
    .min(10, "Enter 10 digit mobile number")
    .max(10, "Enter 10 digit mobile number"),
});

const LoginForm = () => {
  const pathname = useLocation();
  const TEST_SITE_KEY = googleCaptchaAPIKey;
  const recaptchaRef = React.useRef(null);
  const [captchavalue, setCaptchavalue] = React.useState("");
  const onVerifyCaptcha = (captchavalue) => {
    console.log("capcha",captchavalue)
    // setCaptchavalue({ captchavalue });
    setCaptchavalue(captchavalue); 
  };
  // end capcha code
console.log('cal',captchavalue)
  const [agree, setAgree] = useState(false);
  const haveAgree = (event) => {
    setAgree(event.target.checked);
  };

  const [errMessage, setErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");

  const [loading, setLoading] = React.useState(false);
  const [customerId, setCustomerId] = useState("");
  const [cookies, setCookie] = useCookies(["jwt", "huid", "hdetial"]);
  const [{ token }, dispatch] = useStateValue();

  const [isOTP, setIsOTP] = useState(false);

  const [isOTPRegis, setisOTPRegis] = useState(false);
  const [isRegistration, setIsRegistration] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      // password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      var data = new FormData();
      data.append("email", values.email);
      // for (var pair of data.entries()) {
      //     console.log(pair[0] + ', ' + pair[1]);
      // }
      login(data).then((res) => {
        setLoading(false);
        switch (res.data.status) {
          case 1:
            setIsOTP(true);
            //setSusMessage(res.data.msz);
            setTimer(res.data.resendAfter);
            setErrMessage("");
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "success" });
            dispatch({
              type: actionTypes.SET_MSGALERTDATA,
              value: res.data.msz,
            });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return true;
          case 0:
            setTimer(res.data.resendAfter);
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "error" });
            dispatch({
              type: actionTypes.SET_MSGALERTDATA,
              value: res.data.msz,
            });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            break;
          case 2:
            dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });

  const formikotp = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchemaOTP,
    onSubmit: (values) => {
      setLoading(true);
      var data = new FormData();
      data.append("email", formik.values.email);
      data.append("OTP", values.otp);
      loginVerifyOtp(data).then((res) => {
        setLoading(false);
        switch (res.data.status) {
          case 1:
            var userTokenCookie = CryptoJS.AES.encrypt(
              `${res.data.data.accessToken}`,
              "HON_MX46d67ee5d05"
            ).toString();
            dispatch({
              type: actionTypes.SET_TOKEN,
              value: res.data.data.accessToken,
            });
            setCookie("jwt", userTokenCookie, { path: "/", maxAge: 900,secure: true, });
            // setCookie("jwt", userTokenCookie, {
            //     path: '/',
            //     maxAge: 691200,
            //     httpOnly: true,
            //     secure: true,
            //   });

            //                         Varun Garg
            // 3:12 PM
            // setCookie("jwt", userTokenCookie, { path: '/', maxAge: 691200  });
            // You
            // 3:15 PM
            // https://docs.google.com/spreadsheets/d/1dtx6_1sC95qri6ziYkePNkIlWWilVyJAN_xBGzYrpbE/edit?usp=sharing
            // Varun Garg
            // 3:26 PM
            // setCookie("jwt", userTokenCookie, {
            //                             path: '/',
            //                             maxAge: 691200,
            //                             httpOnly: true,
            //                             secure: true,
            //                           });

            var userIDCookie = CryptoJS.AES.encrypt(
              `${res.data.data.customerId}`,
              "HON_MX46d67ee5d05"
            ).toString();
            dispatch({
              type: actionTypes.SET_HUID,
              value: res.data.data.customerId,
            });
            setCookie("huid", userIDCookie, { path: "/",  maxAge: 900,secure: true,  });

            setCookie("hdetial", res.data.data.firstName, {
              path: "/", maxAge: 900,secure: true, 
            });

            dispatch({ type: actionTypes.SET_LOGINMODAL, value: false });

            window.location.reload(false);

            setErrMessage("");
            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });

  const formikregisotp = useFormik({
    initialValues: {
      otp: "",
      // otpemail:''
    },
    validationSchema: validationSchemaRegisOTP,
    onSubmit: (values) => {
      setLoading(true);
      var data = new FormData();
      data.append("customerId", customerId);
      data.append("phoneOTP", values.otp);
      customerOTPVerify(data).then((res) => {
        setLoading(false);
        switch (res.data.status) {
          case 1:
            setSusMessage(res.data.msz);
            setErrMessage("");
            setisOTPRegis(false);
            setIsRegistration(false);
            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });
  const enabledbtn =
    formikregisotp?.values?.otp?.length > 5 ||
    formikregisotp?.values?.otpemail?.length > 5;
  const formikResister = useFormik({
    initialValues: {
      title: "",
      cname: "",
      lname: "",
      mobile: "",
      email: "",
    },
    validationSchema: validationSchemaRegis,
    onSubmit: (values) => {
      //setLoading(true);
      // var rawStr = "hello world!";
      // var wordArray = CryptoJS.enc.Utf8.parse(rawStr);
      // var base64 = CryptoJS.enc.Base64.stringify(wordArray);
      // var wordArray = CryptoJS.enc.Utf8.parse(values.cname + values.mobile);
       const Secret = CryptoJS.SHA256(values.cname + values.mobile).toString();
      // let Secret = CryptoJS.enc.Base64.stringify(wordArray);
      //console.log('base64---', Secret)
      // var parsedWordArray = CryptoJS.enc.Base64.parse(base64);
      // var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);
      // console.log("parsed:",parsedStr);
      var data = new FormData();
      data.append("title", values.title);
      data.append("firstName", values.cname);
      data.append("lastName", values.lname);
      data.append("phone", values.mobile);
      data.append("email", values.email);
      data.append("Secret", Secret);
      data.append("captcha", captchavalue); 
      for (var pair of data.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      customerSignup(data).then((res) => {
        setLoading(false);
        switch (res.data.status) {
          case 1:
            setCustomerId(res?.data?.data?.customerId);
            setisOTPRegis(true);
            setIsRegistration(false);
            setErrMessage("");
            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            break;
          default:
            return;
        }
      });
    },
  });

  //const [timerCount, setTimerCount] = useState(1);
  const [timer, setTimer] = useState(0);
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const resetTimer = function () {
    if (!timer) {
      setTimer(15);
    }
  };

  const enabledbtncapt = captchavalue != "" && agree;
  //const enabledbtncapt = agree;
  return (
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-4 d-none d-lg-block ps-0">
          <div className={`${pathname.pathname.includes("/hi-value-plus") ? "bghivalueplus":"bg-black"} h-100`} style={{ minHeight: "580px" }}>
            {!isRegistration ? (
              <>
                <div className="text-white p-4">
                  <h3 className="mt-5">Login</h3>
                  <p>
                    {pathname.pathname.includes("/hi-value-plus") ? <span>New to HI Value<sup>+</sup>  by {`${pathname.pathname.includes("/hi-value-plus") ? "HIPP":"Honda"}`} — your one-stop platform for certified refurbished power products.Buy with confidence. Sell with ease. Experience quality, value, and trust — all in one place.</span>:"Get access to your Orders, Wishlist and Recommendations."}
                  </p>
                </div>
              </>
            ) : (
              <></>
            )}
            {isRegistration ? (
              <>
                <div className="text-white p-4">
                  <h3 className="mt-5">You're new here!</h3>
                  <p>Sign up with your mobile number or email to get started</p>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="col-lg-8 col-md-12">
          <div className="p-4">
            {token ? <></> : <></>}
            {errMessage ? (
              <>
                <Alert severity="error">{errMessage}</Alert>
              </>
            ) : null}
            {susMessage ? (
              <>
                <Alert severity="success">{susMessage}</Alert>
              </>
            ) : null}
            <div className="row">
              <div className="col-lg-12 mt-4 mb-4">
                {isOTP ? (
                  <>
                    <div className="text-center f14 mb-5">
                      Please enter the 6 Digit OTP sent to
                      <br />
                      <span className="fw-bold">{formik.values.email}</span>.
                      <Link
                        to="#"
                        onClick={() => {
                          setIsOTP(false);
                          setErrMessage("");
                          setSusMessage("");
                        }}
                      >
                        Change
                      </Link>
                    </div>
                    <form onSubmit={formikotp.handleSubmit} autoComplete="off">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        // type="number"
                        inputProps={{
                          maxLength: 6,
                        }}
                        id="otp"
                        name="otp"
                        label="Enter OTP"
                        value={formikotp.values.otp}
                        onChange={formikotp.handleChange}
                        error={
                          formikotp.touched.otp && Boolean(formikotp.errors.otp)
                        }
                        helperText={
                          formikotp.touched.otp && formikotp.errors.otp
                        }
                      />
                      <Button
                        // color="error"
                        variant="contained"
                        className={`${pathname.pathname.includes("/hi-value-plus") ? "bghivalueplus":"bgred"} w-100`}
                        type="submit"
                      >
                        Verify
                      </Button>
                      {timer && timer > 0 ? (
                        <>
                          <div className="col-12 f14 text-muted mt-2">
                            Resend OTP in{" "}
                            <span className="text-success fw-bold">
                              {timer}
                            </span>{" "}
                            Sec
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="f14 mt-3 text-center">
                        Not received your code?{" "}
                        <Button
                          color="error"
                          disabled={timer > 0}
                          variant="text"
                          onClick={formik.handleSubmit}
                          className=""
                        >
                          Resend otp
                        </Button>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    {!isRegistration && !isOTPRegis ? (
                      <>
                        <form onSubmit={formik.handleSubmit} autoComplete="off">
                          <TextField
                            className="mb-5 w-100"
                            variant="standard"
                            id="email"
                            name="email"
                            label="Enter Mobile Number / Email ID"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                          {/* <div className='f12 mb-3'>By continuing, you agree to Honda's <Link to="/privacy-policy" target='_blank'>Terms & Privacy Policy</Link>.</div> */}
                          {!loading ? (
                            <Button
                              // color="error"
                              variant="contained"
                              className={`${pathname.pathname.includes("/hi-value-plus") ? "bghivalueplus":"bgred"} w-100`}
                              type="submit"
                            >
                              Login
                            </Button>
                          ) : (
                            <LoadingButton
                              className="w-100"
                              loading
                              loadingPosition="end"
                              variant="contained"
                            >
                              Login...
                            </LoadingButton>
                          )}
                        </form>
                      </>
                    ) : null}
                  </>
                )}
                {isRegistration ? (
                  <>
                    <form
                      onSubmit={formikResister.handleSubmit}
                      autoComplete="off"
                    >
                      <div className="row">
                        <div className="col-md-4 col-12">
                          <TextField
                            id="title"
                            className="w-100"
                            select
                            label="Title"
                            name="title"
                            variant="standard"
                            value={formikResister.values.title}
                            onChange={formikResister.handleChange}
                            error={
                              formikResister.touched.title &&
                              Boolean(formikResister.errors.title)
                            }
                            helperText={
                              formikResister.touched.title &&
                              formikResister.errors.title
                            }
                          >
                            {titleprofile?.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                        <div className="col-md-4 col-12">
                          <TextField
                            className="mb-4 w-100"
                            variant="standard"
                            id="cname"
                            name="cname"
                            label="First Name *"
                            type="text"
                            value={formikResister.values.cname}
                            //onChange={formikResister.handleChange}
                            onChange={(e) => {
                              formikResister.setFieldValue(
                                "cname",
                                e.target.value.replace(/[^a-z]/gi, "")
                              );
                            }}
                            error={
                              formikResister.touched.cname &&
                              Boolean(formikResister.errors.cname)
                            }
                            helperText={
                              formikResister.touched.cname &&
                              formikResister.errors.cname
                            }
                          />
                        </div>
                        <div className="col-md-4 col-12">
                          <TextField
                            className="mb-4 w-100"
                            variant="standard"
                            id="lname"
                            name="lname"
                            label="Last Name *"
                            type="text"
                            value={formikResister.values.lname}
                            //onChange={formikResister.handleChange}
                            onChange={(e) => {
                              formikResister.setFieldValue(
                                "lname",
                                e.target.value.replace(/[^a-z]/gi, "")
                              );
                            }}
                            error={
                              formikResister.touched.lname &&
                              Boolean(formikResister.errors.lname)
                            }
                            helperText={
                              formikResister.touched.lname &&
                              formikResister.errors.lname
                            }
                          />
                        </div>
                      </div>
                      <TextField
                        variant="standard"
                        className="mb-4 w-100"
                        label="Mobile Number *"
                        inputProps={{
                          maxLength: 10,
                        }}
                        id="mobile"
                        name="mobile"
                        value={formikResister.values.mobile}
                        onChange={(e) => {
                          formikResister.setFieldValue(
                            "mobile",
                            e.target.value.replace(/[^0-9]/g, "")
                          );
                        }}
                        //onChange={formikResister.handleChange}
                        error={
                          formikResister.touched.mobile &&
                          Boolean(formikResister.errors.mobile)
                        }
                        helperText={
                          formikResister.touched.mobile &&
                          formikResister.errors.mobile
                        }
                      />
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="email"
                        name="email"
                        label="Email ID"
                        value={formikResister.values.email}
                        onChange={formikResister.handleChange}
                        error={
                          formikResister.touched.email &&
                          Boolean(formikResister.errors.email)
                        }
                        helperText={
                          formikResister.touched.email &&
                          formikResister.errors.email
                        }
                      />
                      <div className="f12 mb-3">
                        <div className="d-flex align-items-center">
                          <div>
                            {" "}
                            <FormGroup>
                              <FormControlLabel
                                className="f14"
                                control={
                                  <Checkbox
                                    className="f14"
                                    checked={agree}
                                    onChange={haveAgree}
                                  />
                                }
                                label=""
                              />
                            </FormGroup>
                          </div>
                          <div>
                            I accept the{" "}
                            <Link to="/terms-of-use" target="_blank">
                              Terms & Privacy Policy
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-2">
                        <ReCAPTCHA
                          style={{ display: "inline-block" }}
                          theme="light"
                          ref={recaptchaRef}
                          sitekey={TEST_SITE_KEY}
                          onChange={onVerifyCaptcha}
                          onExpired={() => {
                            recaptchaRef.current.reset(); // here
                            setCaptchavalue("");
                          }}
                        />
                      </div>
                      {!loading ? (
                        <Button
                          color="error"
                          disabled={!enabledbtncapt}
                          variant="contained"
                          className="w-100"
                          type="submit"
                        >
                          Register
                        </Button>
                      ) : (
                        <LoadingButton
                          className="w-100"
                          loading
                          //loadingPosition="end"
                          variant="contained"
                        >
                          Register...
                        </LoadingButton>
                      )}
                    </form>
                  </>
                ) : null}
              </div>
              {isOTPRegis ? (
                <>
                  <div className="text-left f14 mb-5">
                    Please enter the 6 Digit OTP sent
                    <br /> to your Mobile{" "}
                    <span className="fw-bold">
                      {formikResister.values.mobile}
                    </span>
                  </div>
                  <form
                    onSubmit={formikregisotp.handleSubmit}
                    autoComplete="off"
                  >
                    <TextField
                      className="mb-4 w-100"
                      variant="standard"
                      // type="number"
                      inputProps={{
                        maxLength: 6,
                      }}
                      id="otp"
                      name="otp"
                      label="Enter 6 Digit Mobile OTP"
                      value={formikregisotp.values.otp}
                      onChange={formikregisotp.handleChange}
                      error={
                        formikregisotp.touched.otp &&
                        Boolean(formikregisotp.errors.otp)
                      }
                      helperText={
                        formikregisotp.touched.otp && formikregisotp.errors.otp
                      }
                    />
                    {!loading ? (
                      <Button
                        color="error"
                        disabled={!enabledbtn}
                        variant="contained"
                        className="w-100"
                        type="submit"
                      >
                        Verify OTP
                      </Button>
                    ) : (
                      <LoadingButton
                        className="w-100"
                        loading
                        // loadingPosition="end"
                        variant="contained"
                      >
                        Verify OTP...
                      </LoadingButton>
                    )}
                    {/* <div className='f14 mt-3 text-center'>Not received your code? <Link to="#">Resend code</Link></div> */}
                  </form>
                </>
              ) : null}
              <div className="text-center">
                {!isOTP && !isOTPRegis ? <>OR</> : null}
              </div>
              <div className="text-center mt-3 fw-bold mb-3">
                {isRegistration ? (
                  <>
                    Existing User?{" "}
                    <Link to="#" onClick={() => setIsRegistration(false)}>
                      Log in
                    </Link>
                  </>
                ) : (
                  <>
                    {!isOTP && !isOTPRegis ? (
                      <>
                        {pathname.pathname.includes("/hi-value-plus") ?<span>New to HI Value<sup>+</sup> ?</span> :"New to Honda?"}{" "}
                        <Link to="#" onClick={() => setIsRegistration(true)}>
                          Create an account
                        </Link>
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
